import React, { Fragment } from "react";
import { TextField, Stack, Button } from "@mui/material";
import { PRICES_BASE_REQUEST } from "../../../../../../../../enums/ApiPaths";
import { useForm, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { zodResolver } from "@hookform/resolvers/zod";
import { clinicServiceFormResolver } from "../utils/ClinicServiceFromResolver";
import { SERVICES } from "../../../../../../../../enums/QueryKeys";
import usePut from "../../../../../../../../hooks/usePut";
import { useQueryClient } from "@tanstack/react-query";
import { serviceMaxTitle, serviceMaxDesc } from "../../../../../../../services/form/ServiceForm";

export default function ServiceTitleForm({ price, clinicId }) {
  const { t } = useTranslation();
  const queryClient = useQueryClient();
  const editPath = PRICES_BASE_REQUEST + clinicId;
  const edit = usePut(editPath, SERVICES + clinicId);
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      description: price?.description,
      title: price?.title,
    },
    resolver: zodResolver(clinicServiceFormResolver(t)),
  });

  const editSubmit = async (data) => {
    const obj = {
      id: price?.id,
      title: data.title,
      description: data?.description,
    };
   const res = await edit.submitCallback(obj);
   if (res) {
     reset(data);
     queryClient.invalidateQueries(SERVICES + clinicId);
   }
  };
  return (
    <Fragment>
      <form onSubmit={handleSubmit(editSubmit)}>
        <Stack spacing={2}>
          <Controller
            name="title"
            control={control}
            rules={{ required: t("CantBeEmpty") }}
            render={({ field }) => (
              <TextField
                {...field}
                label={price.title}
                fullWidth
                error={!!errors.title}
                helperText={errors.title ? errors.title.message : ""}
                inputProps={{
                  maxLength: serviceMaxTitle,
                  "data-testid": "service.edit.fallback-title.title-input",
                }}
              />
            )}
          />
          <Controller
            name="description"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label={t("Description")}
                fullWidth
                error={!!errors.description}
                helperText={
                  errors.description ? errors.description.message : ""
                }
                inputProps={{
                  maxLength: serviceMaxDesc,
                  "data-testid": "service.edit.fallback-title.description-input",
                }}
              />
            )}
          />
        </Stack>
        <Stack direction={"row"} alignItems={"center"} spacing={2} mt={2}>
          <Button
            variant="contained"
            color="info"
            sx={{ mt: 2 }}
            type="submit"
            data-testid="service.edit.fallback-title.save-button"
          >
            {t("Save")}
          </Button>
        </Stack>
      </form>
    </Fragment>
  );
}
